import { useCoachNavigation } from '@/features/coach/CoachNavigation'
import type { ComponentProps } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { usePlayMenu } from './playMenuContext'

type Props = Omit<ComponentProps<typeof Link>, 'to'> & {
  to: string
  onNavigate?: () => void
}

export default function PlayNavigationLink({ to, onNavigate, onClick, ...props }: Props) {
  const navigation = useCoachNavigation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const menu = usePlayMenu()

  return (
    <Link
      {...props}
      to={to}
      onClick={event => {
        onClick?.(event)
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        )
          return
        event.preventDefault()
        if (menu?.open && menu.beforeNavigate) {
          if (menu.beforeNavigate() === false) return
        } else if (pathname !== to && navigation && !navigation.mayNavigate()) return
        navigate(to)
        onNavigate?.()
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      }}
    />
  )
}
